import { Toast } from "radix-ui";
import "./FreeTrialNotif.css";

interface FreeTrialNotifProps {
	open: boolean;
	onOpen: (open: boolean) => void;
	freeTrialsRemaining: number;
	freeTrialLimit: number;
}

const FreeTrialNotif = ({ open, onOpen: setOpen, freeTrialsRemaining, freeTrialLimit }: FreeTrialNotifProps) => {
	return (
		<Toast.Provider swipeDirection="right">
			<Toast.Root className="ToastRoot" open={open} onOpenChange={setOpen}>
				<Toast.Title className="ToastTitle">Your Free Trial</Toast.Title>
				<Toast.Description asChild>
					<p className="text-sm">You have {freeTrialsRemaining} out of {freeTrialLimit} procedures remaining. <a href="https://www.manufacture-ai.com/pricing-plans/list">Upgrade your plan</a> for more.</p>
				</Toast.Description>
				<Toast.Action
					className="ToastAction"
					asChild
					altText="Upgrade"
				>
					<button className="Button small green cursor-pointer" onClick={() => window.open("https://www.manufacture-ai.com/pricing-plans/list", "_blank")}>Upgrade</button>
				</Toast.Action>
			</Toast.Root>
			<Toast.Viewport className="ToastViewport" />
		</Toast.Provider>
	);
};

export default FreeTrialNotif;
